import React, { useState } from 'react';
import { Modal, Box, FormControl, Typography,Alert,Snackbar,TextField, Tooltip, Button, Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { grey, red } from '@mui/material/colors';
import BASE_URL from '../../config'

const style = {
  position: 'absolute', 
  top: '50%', 
  left: '50%', 
  transform: 'translate(-50%, -50%)',
  bgcolor: 'white', 
  borderRadius: 4, p: 4, 
  outline: 'none',
  width: { xs: '90%', sm: '500px' }, 
  maxHeight: '85%', 
  overflowY: 'auto',
  '&::-webkit-scrollbar': { display: 'none' },
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
};

const listaPermisos = [
  'Gestionar Usuarios', 'Gestionar Roles', 'Gestionar Clientes', 'Gestionar reportes',
  'Gestionar equipos/soluciones', 'Gestionar Tareas','Gestionar Agenda','Ver Agenda', 'Ver Reportes', 'Configuración Sistema'
];

export default function Modalnewrol({ open, handleClose, refreshRoles }) {
  const [roleData, setRoleData] = useState({ nombre: '', descripcion: '', permisos: [] });
  const [confirmType, setConfirmType] = useState(null);
  const [error, setError] = useState(false); // Cambiado a booleano para consistencia
  const [isFocused, setIsFocused] = useState(false);
  const [isNameFocused, setIsNameFocused] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const validateAndOpenSave = () => {
    const isNombreEmpty = !roleData.nombre.trim();
    const isDescEmpty = !roleData.descripcion.trim();
    const isPermisosEmpty = roleData.permisos.length === 0;

    if (isNombreEmpty || isDescEmpty || isPermisosEmpty) {
      setError(true);
    } else {
      setError(false);
      setConfirmType('save');
    }
  };

  const handleCheck = (permiso) => {
    const isChecked = roleData.permisos.includes(permiso);
    setRoleData({
      ...roleData,
      permisos: isChecked 
        ? roleData.permisos.filter(p => p !== permiso) 
        : [...roleData.permisos, permiso]
    });
  };

  const resetModal = () => {
    setRoleData({ nombre: '', descripcion: '', permisos: [] });
    setConfirmType(null);
    setError(false);
    handleClose();
  };

  const handleSubmit = async () => {
    try {
      const res = await fetch(`${BASE_URL}/roles`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(roleData)
      });
      if (res.ok) {
        setSnackbar({ open: true, message: 'Rol creado con éxito', severity: 'success' });
        resetModal();
        refreshRoles();
      }
    } catch (e) { console.error(e); }
  };

  if (confirmType) {
    return (
      <Modal open={open} onClose={() => setConfirmType(null)}>
        <Box sx={style}>
          <Box sx={{display:'flex',flexDirection:'column',gap:1}}>
            <Typography variant="h6" textAlign="start" >
              {confirmType === 'cancel' ? '¿Cancelar nuevo rol?' : '¿Crear nuevo rol?'}
            </Typography>
            <Typography variant="body1" color='textSecondary' >
              {confirmType === 'cancel' ? 'Los datos ingresados se perderán.¿Estás seguro que deseas cancelar?' : '¿Estás seguro que deseas crear este nuevo rol?'}
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, mt:2 , justifyContent:'end' }}>
              <Button fullWidth 
                      variant="contained" 
                      sx={{bgcolor:grey[100], color:'black',textTransform: 'none',width: { xs: '50%', sm: '42%' }}} 
                      onClick={() => setConfirmType(null)}>
                {confirmType === 'cancel' ? 'No, continuar editando' : 'No, revisar datos'}
              </Button>
              <Button fullWidth 
                      variant="contained" 
                      sx={{ bgcolor: 'black', textTransform: 'none',width: { xs: '50%', sm: '25%' } }} 
                      onClick={confirmType === 'cancel' ? resetModal : handleSubmit}>
                      {confirmType === 'cancel' ? 'Sí, cancelar' : 'Sí, guardar'}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    );
  }

  const boxstyle = {
      mx: 0.3,
      width:'auto', 
      maxHeight: '100px', 
      overflowY: 'auto', 
      bgcolor: 'white',
      '&::-webkit-scrollbar': { height: '6px', width: '6px',display:'none' },
      '&::-webkit-scrollbar-thumb': { background: grey[300], borderRadius: '8px' },
      '&::-webkit-scrollbar-thumb:hover': { background: grey[500] },
    };

  const Inputstyle = {
      '& .MuiOutlinedInput-root': {
        bgcolor: '#f5f5f5',
        borderRadius: '8px',
        '& fieldset': { borderColor: 'transparent' },
        '&:hover fieldset': { borderColor: grey[400] },
        '&.Mui-focused fieldset': { borderColor: grey[600] },
      },
    };
  

  return (
  <>
    <Modal open={open} onClose={() => setConfirmType('cancel')}>
      <Box sx={style}>
        <Box sx={{display:'flex',gap:2,flexDirection:'column',height:'100%'}}>
          
          <Box>
            <Typography variant="h6">Crear Nuevo Rol</Typography>
            <Typography variant="subtitle1" color='textSecondary' >Completa la información del rol</Typography>
          </Box>

          <FormControl>
            <Typography>Nombre del rol</Typography>
            <Tooltip 
              title="Debes completar este campo" 
              open={(isNameFocused || error) && !roleData.nombre.trim()}
              placement="top-end" 
              arrow
              componentsProps={{ tooltip: { sx: { bgcolor: red[700] } }, arrow: { sx: { color: red[700] } } }}
            >
              <TextField 
                fullWidth
                sx={Inputstyle} 
                error={error && !roleData.nombre.trim()}
                value={roleData.nombre}
                onFocus={() => setIsNameFocused(true)}
                onBlur={() => setIsNameFocused(false)}
                onChange={(e) => setRoleData({...roleData, nombre: e.target.value})} 
              />
            </Tooltip>
          </FormControl>
            
          <FormControl>
            <Typography>Descripción</Typography>
            <Tooltip 
              title="Debes completar este campo" 
              open={(isFocused || error) && !roleData.descripcion.trim()}
              placement="top-end" 
              arrow
              componentsProps={{ tooltip: { sx: { bgcolor: red[700] } }, arrow: { sx: { color: red[700] } } }}
            >
              <TextField  
                variant='outlined'
                fullWidth 
                multiline 
                rows={2} 
                sx={Inputstyle}  
                error={error && !roleData.descripcion.trim()}
                value={roleData.descripcion}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                onChange={(e) => setRoleData({...roleData, descripcion: e.target.value})} 
                />
            </Tooltip>
          </FormControl>
          
          <FormGroup>
            <Typography variant="body1">Permisos</Typography>
            <Tooltip 
              title="Debes seleccionar al menos un permiso" 
              open={error && roleData.permisos.length === 0} 
              placement="top-end" 
              arrow
              componentsProps={{ tooltip: { sx: { bgcolor: red[700], fontWeight: 'bold' } }, arrow: { sx: { color: red[700] } } }}
            >
              <Box sx={{ 
                px:0,
                py:1,
                overflow: 'hidden',
                width: '100%',
                boxSizing: 'border-box',
                border: `1px solid ${error && roleData.permisos.length === 0 ? red[700] : grey[300]}`, 
                borderRadius: '8px'}}>
                  <Box sx={boxstyle}>
                    {listaPermisos.map((permiso) => (
                      <Box
                        key={permiso}
                        sx={{
                          ':hover ': { bgcolor: grey[100] } ,
                          display: 'flex',
                          alignItems: 'center',
                          height: '35px',
                          width: 'max-content',
                          minWidth: '100%',
                          }}>
                        <FormControlLabel 
                          control={<Checkbox sx={{ml:1}} size="medium"checked={roleData.permisos.includes(permiso)} onChange={() => handleCheck(permiso)}/>}
                          label={<Typography variant="body1" sx={{userSelect: 'none'}}>{permiso}</Typography>}
                          sx={{ margin: 0,width: '100%',}}
                        />
                      </Box>
                    ))}
                  </Box>
              </Box>
            </Tooltip>
          </FormGroup>

          <Box sx={{display:'flex',flexDirection:'row',justifyContent:'end'}}>
            <Button  
              variant="contained" 
              color='primary'
              sx={{bgcolor:grey[100], color:'black', width: { xs: '50%', sm: '25%' },textTransform: 'none',mr:1, '&:hover': {bgcolor: grey[200]}}} 
              onClick={() => setConfirmType('cancel')}>
              Cancelar
            </Button>
            <Button 
              variant="contained" 
              sx={{ bgcolor: 'black',ml:1, textTransform: 'none',width: { xs: '50%', sm: '25%' } }} 
              onClick={validateAndOpenSave}
            >
              Crear Rol
            </Button>
          </Box>

        </Box>
      </Box>
    </Modal>
    <Snackbar open={snackbar.open} autoHideDuration={2500} onClose={() => setSnackbar({ ...snackbar, open: false })} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
      <Alert severity={snackbar.severity} variant="filled" sx={{ width: '100%', borderRadius: '10px' }}>
        {snackbar.message}
      </Alert>
    </Snackbar>
  </>
  );
}